export class StepUpChallengeResponse {
    stateToken: string;
    factorId: string;

    constructor(json: any) {
        this.stateToken = json.state_token;
        this.factorId = json.factor_id;
    }
}
